import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { selectProductSearchResultsConfig } from 'core/modules/ProductSearchResults/selectors';

import { triggerPrsApplySortGaEvent } from 'core/modules/ProductSearchResults/actions';

function SortDesktop({ productResultsHook }) {
  const dispatch = useDispatch();
  const { sortOptions } = useSelector(selectProductSearchResultsConfig);
  const { fetchSortedProducts, searchParams } = productResultsHook;

  const handleOnChange = (sortType) => {
    fetchSortedProducts(sortType);
    dispatch(triggerPrsApplySortGaEvent(sortType));
  };

  return (
    <div className="mn_sort">
      <label htmlFor="mn_sortDropdown">Sort by:</label>
      <select
        className="mn_sortDropdown"
        name="mn_sortDropdown"
        id="mn_sortDropdown"
        onChange={e => handleOnChange(e.target.value)}
        defaultValue={searchParams.sort_by}
      >
        {sortOptions.map(({ sortBy, viewName }) => (
          <option key={sortBy} value={sortBy}>
            {viewName}
          </option>
        ))}
      </select>
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><SortDesktop {...props} /></ComponentErrorBoundary>;
